// UI Constants - extracted magic numbers for maintainability

// Breakpoints
export const MOBILE_BREAKPOINT = 768;

// Catalogue Flipbook dimensions
export const FLIPBOOK = {
  MIN_WIDTH: 250,
  MAX_WIDTH: 420,
  MIN_HEIGHT: 354,
  MAX_HEIGHT: 594,
  DEFAULT_WIDTH: 350,
  DEFAULT_HEIGHT: 495,
  FULLSCREEN_MAX_WIDTH: 700,
  FULLSCREEN_HEADER_HEIGHT: 140,
  FULLSCREEN_PADDING: 100,
  A4_RATIO: 1.414,
  MOBILE_HEIGHT: 450,
  DESKTOP_HEIGHT: 520,
  PAGE_TOP_OFFSET: 340,
};

// Services section icon sizes
export const ICON_SIZE = {
  SMALL: 12,
  MEDIUM: 18,
  DEFAULT: 20,
  LARGE: 22,
  XL: 24,
  XXL: 32,
  XXXL: 48,
  HERO: 64,
  HUGE: 80,
};

// Video dimensions
export const VIDEO = {
  GALLERY_HEIGHT: 300,
  MODEL_IMAGE_HEIGHT: 250,
  HERO_MOBILE_HEIGHT: 400,
  HERO_DESKTOP_HEIGHT: 650,
};

// Image dimensions
export const IMAGE = {
  SPECIALTY_HEIGHT: 280,
  MAP_HEIGHT: 300,
  LIGHTBOX_MAX_HEIGHT: '90vh',
};
